import { PendingPremiumDetail } from '#interfaces/executive-report/pending-premium-detail.interface';
import { ProductWithDatasheetsReportResponseDto } from '#interfaces/executive-report/product-datasheet-report.interface';
import { ProductReserveDetailReportDto } from '#interfaces/executive-report/product-reserve-detail.interface';
import { ProjectTotalReservedIncomeDetailReportDto } from '#interfaces/executive-report/project-income-reserve-detail.interface';
import { ProjectTotalReservedIncomePaymentDetailReportDto } from '#interfaces/executive-report/reserve-income-payment-detail.interface';
import { PagedResponse } from '#interfaces/http-response/responses/api-response.interface';
import { ApiResponseData } from '#interfaces/http-response/responses/http-responses';
import { HeadersHttpService } from '#utils/http-headers/http-headers.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExecutiveReportService, PaymentOrdersFeesDetailReportQuery, PendingPremiumAmountReceivableReportQuery, ProductReserveDetailReportQuery } from './executive-report.interface';
import { PaymentOrdersFeesDetailReportDto } from '#interfaces/executive-report/payment-oder-fees-detail-report.interface';

@Injectable({
  providedIn: 'root'
})
export class ExecutiveReportServiceImpl implements ExecutiveReportService {
  baseUrl: string = `${environment.baseUrl}ExecutiveReport/`;

  constructor(private readonly httpClient: HttpClient, private readonly httpHeaderService: HeadersHttpService) {}

  GetPendingPremiumAmountReceivableReport(query: PendingPremiumAmountReceivableReportQuery): Observable<ApiResponseData<PagedResponse<PendingPremiumDetail>>> {
    return this.httpClient
      .get<ApiResponseData<PagedResponse<PendingPremiumDetail>>>(`${this.baseUrl}GetPendingPremiumAmountReceivableReport`, {
        params: {
          ...query},
        headers: this.httpHeaderService.getHeadersPrivate()
      })
      .pipe(
        catchError((error) => {
          return throwError(() => error as HttpErrorResponse);
        })
      );
  }

  GetProjectTotalReservedIncomeDetailReport(query: {
    projectId: number | null;
    parameter: string | null;
    pageNumber: number;
    pageSize: number;
    order: string | null;
    column: string | null;
    all: boolean;
  }): Observable<PagedResponse<ProjectTotalReservedIncomeDetailReportDto>> {
    return this.httpClient
      .get<PagedResponse<ProjectTotalReservedIncomeDetailReportDto>>(`${this.baseUrl}GetProjectTotalReservedIncomeDetailReport`, {
        params: {
          ...query
        },
        headers: this.httpHeaderService.getHeadersPrivate()
      })
      .pipe(
        catchError((error) => {
          return throwError(() => error as HttpErrorResponse);
        })
      );
  }

  GetProjectTotalReservedIncomePaymentDetailReport(query: {
    projectId: number | null;
    paymentType: string | null;
    parameter: string | null;
    pageNumber: number;
    pageSize: number;
    order: string | null;
    column: string | null;
    all: boolean;
  }): Observable<PagedResponse<ProjectTotalReservedIncomePaymentDetailReportDto>> {
    return this.httpClient
      .get<PagedResponse<ProjectTotalReservedIncomePaymentDetailReportDto>>(`${this.baseUrl}GetProjectTotalReservedIncomePaymentDetailReport`, {
        params: {
          ...query
        },
        headers: this.httpHeaderService.getHeadersPrivate()
      })
      .pipe(
        catchError((error) => {
          return throwError(() => error as HttpErrorResponse);
        })
      );
  }

  GetProductReservesDetailReport(query: ProductReserveDetailReportQuery): Observable<PagedResponse<ProductReserveDetailReportDto>> {
    return this.httpClient
      .get<PagedResponse<ProductReserveDetailReportDto>>(`${this.baseUrl}GetProductReservesDetailReport`, {
        params: {
          ...query
        },
        headers: this.httpHeaderService.getHeadersPrivate()
      })
      .pipe(
        catchError((error) => {
          return throwError(() => error as HttpErrorResponse);
        })
      );
  }

  GetProductDatasheetReport(query: ProductReserveDetailReportQuery): Observable<ProductWithDatasheetsReportResponseDto> {
    return this.httpClient
      .get<ProductWithDatasheetsReportResponseDto>(`${this.baseUrl}GetProductDatasheetReport`, {
        params: {
          ...query
        },
        headers: this.httpHeaderService.getHeadersPrivate()
      })
      .pipe(
        catchError((error) => {
          return throwError(() => error as HttpErrorResponse);
        })
      );
  }

  GetPaymentOrdersFeesDetailReport(query: PaymentOrdersFeesDetailReportQuery): Observable<PagedResponse<PaymentOrdersFeesDetailReportDto>> {
    return this.httpClient
      .get<PagedResponse<PaymentOrdersFeesDetailReportDto>>(`${this.baseUrl}GetPaymentOrdersFeesDetailReport`, {
        params: {
          ...query
        },
        headers: this.httpHeaderService.getHeadersPrivate()
      })
      .pipe(
        catchError((error) => {
          return throwError(() => error as HttpErrorResponse);
        })
      );
  }

}
